import { post } from "../../services";
import { LIST_ADMIN_CONFIGS, SET_ADMIN_CONFIGS } from "../../graphql";
import { TOGGLE_LOADING } from "../types";

export const listAdminConfigs = (category) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: LIST_ADMIN_CONFIGS,
            variables: category ? { category } : {},
        });

        if (apiResponse.data.customStatus) {
            const { list_admin_configs: { data } } = apiResponse.data.data;
            dispatch({ type: TOGGLE_LOADING, payload: false });
            return data;
        }
        dispatch({ type: TOGGLE_LOADING, payload: false });
        return null;
    };
};

// configs: [{ key, value }]. The backend rejects the whole batch if any value is invalid,
// so a partial save is not a state this can land in.
export const setAdminConfigs = (configs) => {
    return async (dispatch) => {
        dispatch({ type: TOGGLE_LOADING, payload: true });

        let apiResponse = await post("", {
            query: SET_ADMIN_CONFIGS,
            variables: { configs },
        });

        dispatch({ type: TOGGLE_LOADING, payload: false });
        return Boolean(apiResponse.data.customStatus);
    };
};
